import React, { useState, useEffect } from "react";
import { Button, Table, Form } from "react-bootstrap";
import axios from "axios";
import { API_BASE_URL } from "../../utils/config";
import NewTopNavBar from "../NewTopNavBar";
import CreateImg from "../../Img/create.png";
function TokenManager() {
  const [platform, setPlatform] = useState(""); // Initial selection
  const [isEditMode, setIsEditMode] = useState(false);
  const [isactive, setIsActive] = useState(false);
  const [jiraCred, setJiraCred] = useState({
    user_id: "",
    password: "",
  });
  const [tokenData, setTokenData] = useState({
    email: "",
    redirect_uri: "",
    refreshToken: { token: "", addedAt: "" },
    accessToken: { token: "", addedAt: "" },
    clientID: "",
    clientSecret: "",
  });
  const [showTable, setShowTable] = useState(false);

  let bearerToken = localStorage.getItem("jwt_token");
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const fetchCurrentValue = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/wp-json/custom/v1/ticketing-platform-selection`,
        config
      );
      if (response.data) {
        setPlatform(response.data.value);
      }
    } catch (error) {
      console.error("Error fetching current option value:", error);
    }
  };

  const getTokenData = () => {
    // alert("dsfdg");
    // Fetch the existing data (for example from a GET API)
    let apiUrl = `${API_BASE_URL}/wp-json/custom/v1/tokens`;
    // if (platform === "zoho") {
    //   apiUrl = `${API_BASE_URL}/wp-json/custom/v1/tokens`;
    // } else {
    //   apiUrl = `${API_BASE_URL}/wp-json/jira/v1/credentials`;
    // }
    axios
      .get(apiUrl, config)
      .then((response) => {
        setTokenData(response.data);

        setIsEditMode(true);
        // setShow(true);
      })
      .catch((error) => console.error("Error fetching token data:", error));

    axios
      .get(`${API_BASE_URL}/wp-json/jira/v1/credentials`, config)
      .then((response) => {
        setJiraCred(response.data);
        setIsEditMode(true);
        // setShow(true);
      })
      .catch((error) => console.error("Error fetching token data:", error));
  };
  const handleSubmitCheckActive = async (data) => {
    setPlatform(data);

    try {
      await axios.post(
        `${API_BASE_URL}/wp-json/custom/v1/ticketing-platform-selection`,
        { value: data },
        config
      );
      setIsEditMode(isEditMode ? false : true);
      setShowTable(true); // Show table on change
    } catch (error) {
      console.error("Error updating option:", error);
    }
  };

  useEffect(() => {
    // Fetch initial token selection value on mount

    fetchCurrentValue();
    getTokenData();
  }, [isEditMode]);

  // Handle selection change between "Zoho" and "Jira"
  const handleChange = async (event) => {
    const newValue = event.target.value;
    setPlatform(newValue);

    try {
      await axios.post(
        `${API_BASE_URL}/wp-json/custom/v1/ticketing-platform-selection`,
        { value: newValue },
        config
      );
      setIsEditMode(isEditMode ? false : true);
      setShowTable(true); // Show table on change
    } catch (error) {
      console.error("Error updating option:", error);
    }
  };

  // Handle input changes for Zoho or Jira fields
  // const handleInputChange = (e) => {
  //   // Check if the input is for refreshToken or accessToken nested fields
  //   const { name, value } = e.target;
  //   if (platform === "zoho") {
  //     if (name.includes(".")) {
  //       const [tokenType, field] = name.split(".");
  //       setTokenData((prevState) => ({
  //         ...prevState,
  //         [tokenType]: {
  //           ...prevState[tokenType],
  //           [field]: value,
  //         },
  //       }));
  //     } else {
  //       setTokenData((prevState) => ({
  //         ...prevState,
  //         [name]: value,
  //       }));
  //     }
  //   } else {
  //     setJiraCred((prevState) => ({ ...prevState, [name]: value }));
  //   }
  // };

  // Handle input changes
  const handleInputChange = (e, data) => {
    const { name, value } = e.target;
    if (data === "zoho") {
      if (name.includes("refreshToken") || name.includes("accessToken")) {
        const [tokenType, field] = name.split(".");
        setTokenData((prevState) => ({
          ...prevState,
          [tokenType]: { ...prevState[tokenType], [field]: value },
        }));
      } else {
        setTokenData((prevState) => ({ ...prevState, [name]: value }));
      }
    } else {
      setJiraCred((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  // Handle form submission
  const handleSubmit = (event, data) => {
    event.preventDefault();
    const method = isEditMode ? "PUT" : "POST";
    let url =
      method === "POST"
        ? `${API_BASE_URL}/wp-json/custom/v1/tokens`
        : `${API_BASE_URL}/wp-json/custom/v1/tokens/edit`;

    if (data === "zoho") {
      axios
        .post(url, tokenData, config)
        .then((response) => {
          console.log("Data saved:", response.data);
          setShowTable(false); // Hide table after save
        })
        .catch((error) => console.error("Error saving token data:", error));
    } else {
      axios
        .post(`${API_BASE_URL}/wp-json/jira/v1/credentials`, jiraCred, config)
        .then(() => setShowTable(false))
        .catch((error) => console.error("Error saving token data:", error));
    }
  };

  return (
    <div>
      <NewTopNavBar />
      <div className="text-center pt-5 container">
        <h4 className="pb-5">Manage Token</h4>

        {/* Token type selection */}
        <Form.Group className="mb-3 d-flex d-none">
          <Form.Label className="pe-3 fw-bold">Select Platform:</Form.Label>
          <Form.Control
            as="select"
            className="w-25"
            value={platform}
            onChange={handleChange}
          >
            <option value="jira">Jira</option>
            <option value="zoho">Zoho</option>
          </Form.Control>
        </Form.Group>

        {/* Table for token data input */}
        {/* {showTable && ( */}
        <Table striped bordered hover>
          <thead>
            {/* {platform === "zoho" ? ( */}
            <tr>
              <th>Platform</th>
              <th>Email </th>
              <th>Redirect URI </th>
              <th>Client ID </th>
              <th>Client Secret</th>
              <th>Action</th>
              <th>Status</th>
              {/* <th>User ID</th>
              <th>Password</th>
              <th>Action</th> */}
            </tr>
            {/* ) : (
              <tr>
                <th>Platform</th>
                <th>User ID</th>
                <th>Password</th>
                <th>Action</th>
              </tr>
            )} */}
          </thead>
          <tbody>
            <tr>
              <td>Zoho</td>
              {/* <td>
                <Form.Control
                  as="select"
                  // className="w-25"
                  value={platform}
                  onChange={handleChange}
                >
                  <option value="jira">Jira</option>
                  <option value="zoho">Zoho</option>
                </Form.Control>
              </td> */}

              <>
                <td>
                  <Form.Control
                    type="email"
                    name="email"
                    value={tokenData.email}
                    onChange={(e) => handleInputChange(e, "zoho")}
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    name="redirect_uri"
                    value={tokenData.redirect_uri}
                    onChange={(e) => handleInputChange(e, "zoho")}
                  />
                </td>
                <td>
                  <Form.Control
                    type="password"
                    name="clientID"
                    value={tokenData.clientID}
                    onChange={(e) => handleInputChange(e, "zoho")}
                  />
                </td>
                <td>
                  <Form.Control
                    type="password"
                    name="clientSecret"
                    value={tokenData.clientSecret}
                    onChange={(e) => handleInputChange(e, "zoho")}
                  />
                </td>
                {/* <td colSpan="2">—</td> */}
              </>

              <td>
                <Button variant="" onClick={(e) => handleSubmit(e, "zoho")}>
                  {/* {isEditMode ? "Save Changes" : "Add Token"} */}
                  <img src={CreateImg} />
                </Button>
              </td>
              <td>
                <Button
                  variant=""
                  onClick={() => handleSubmitCheckActive("zoho")}
                >
                  {platform === "zoho" ? "InActive" : "Active"}
                </Button>
              </td>
            </tr>
            <tr>
              <>
                <td>Jira</td>
                <td colSpan="2">—</td>

                <td>
                  <Form.Control
                    type="text"
                    name="user_id"
                    value={jiraCred.user_id}
                    onChange={(e) => handleInputChange(e, "jira")}
                  />
                </td>
                <td>
                  <Form.Control
                    type="password"
                    name="password"
                    value={jiraCred.password}
                    onChange={(e) => handleInputChange(e, "jira")}
                  />
                </td>
              </>
              <td>
                <Button variant="" onClick={(e) => handleSubmit(e, "jira")}>
                  {/* {isEditMode ? "Save Changes" : "Add Token"} */}
                  <img src={CreateImg} />
                </Button>
              </td>
              <td>
                <Button
                  variant=""
                  onClick={() => handleSubmitCheckActive("jira")}
                >
                  {platform === "jira" ? "InActive" : "Active"}
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
        {/* )} */}
      </div>
    </div>
  );
}

export default TokenManager;
